import { usePumpSizing } from "../../context/PumpSizingContext";
import { GpmModeSelector } from "../shared/GpmModeSelector";
import { TextField } from "../shared/TextField";
import { GpmSumpHelp } from "./gpm/GpmSumpHelp";
import { GpmSepticHelp } from "./gpm/GpmSepticHelp";
import { GpmSewageHelp } from "./gpm/GpmSewageHelp";

function GpmHelpForm() {
	const { formData } = usePumpSizing();

	switch (formData.applicationType) {
		case "sump":
			return <GpmSumpHelp />;
		case "septic":
			return <GpmSepticHelp />;
		case "sewage":
			return <GpmSewageHelp />;
		default:
			return null;
	}
}

export function StepGpm() {
	const { formData, setGpmMode, setKnownGpm } = usePumpSizing();
	const { gpmData, applicationType } = formData;

	if (applicationType === "email") {
		return (
			<div className="pf-step pf-step--gpm">
				<TextField
					label="GPM"
					type="number"
					value={gpmData.knownGpm}
					onChange={(event) => setKnownGpm(event.target.value)}
					min="0"
					step="any"
					className="pf-field-group--medium"
				/>
			</div>
		);
	}

	return (
		<div className="pf-step pf-step--gpm">
			<GpmModeSelector
				mode={gpmData.mode}
				knownGpm={gpmData.knownGpm}
				onModeChange={setGpmMode}
				onKnownGpmChange={setKnownGpm}
			/>

			{gpmData.mode === "help" ? <GpmHelpForm /> : null}
		</div>
	);
}
